import CryptoJSCore from "crypto-js/core";
import AES from "crypto-js/aes";
//Limitless imports
import { log as pilog } from "@limitless/common/utils";

const encryptToLocalStorage = (config, state) => {
    const { secretKey, storageKey } = config;
    const log = pilog.getLogger("LocalStorageEncryption encryptToLocalStorage");

    const dataToSave = {};
    try {
        Object.keys(state).map(key => {
            const data = AES.encrypt(JSON.stringify(state[key]), secretKey).toString();
            dataToSave[key] = JSON.stringify(data);
        });
        localStorage.setItem(storageKey, JSON.stringify(dataToSave));
    } catch (error) {
        log.warn("Could not encrypt state to local storage %o", error);
    }
};

const decryptFromLocaleStorage = config => {
    const { secretKey, storageKey } = config;
    const log = pilog.getLogger("LocalStorageEncryption decryptFromLocaleStorage");

    const data = localStorage.getItem(storageKey);

    if (!data) {
        return null;
    }

    try {
        const dataToRehydrate = JSON.parse(data);
        const state = {};
        Object.keys(dataToRehydrate).map(key => {
            const bytes = AES.decrypt(JSON.parse(dataToRehydrate[key]), secretKey);
            state[key] = JSON.parse(bytes.toString(CryptoJSCore.enc.Utf8));
        });

        return state;
    } catch {
        log.warn("Could not decrypt state from local storage");

        return null;
    }
};

export const createEncryptor = config => {
    const saveToLocalStorage = state => encryptToLocalStorage(config, state);
    const getFromLocalStorage = () => decryptFromLocaleStorage(config);

    return {
        saveToLocalStorage,
        getFromLocalStorage
    };
};
